module.exports = __webpack_public_path__ + "img/cat-3.c231c9e1.svg";